import { gql } from '@apollo/client';

export const GET_BOOK_DATA = gql`
  query Book($id: ID!) {
    book(id: $id) {
      id
      title
      authors {
        full_name
        initials
      }
      docviewer_htmls_urls
      docviewer_thumbnails_urls
      outline
      publisher
      pub_place
      innerPagesCount
      pubDate
      is_on_shelf
      shortBibl
      bookmarks {
        page
        text
        ts
      }
      search_index_url
      text_by_pages_url
      last_read_page
      langs {
        id
        title
      }
      access_for_current_user
    }
    me {
      uid
      target_audience_id
    }
  }
`;
